const {locale} = require('../../config.json');

const isString = str => Object.prototype.toString.call(str) === "[object String]";

const padNumber = (num, pad = 2) => (Array(pad).fill('0').join('') + num).slice(-pad);

const isValidDate = d =>d instanceof Date && !isNaN(d);

const dateFromString = str => {
  // convert SS page date format to ISO
  const matches = str && isString(str) ? str.match(/^(\d{4}-\d{1,2}-\d{1,2})\s+(\d{1,2}:\d{1,2}(:\d{1,2})?)\sUTC$/) : null;
  if (matches && matches.length >= 3) {
    str = matches[1] + 'T' + matches[2] + 'Z';
  }

  const date = str ? new Date(Date.parse(str)) : null;

  return isValidDate(date) ? date : null;
}

const dateToUnixTimestamp = date => Math.round(date.getTime() / 1000);

const formatDate = val => {
  const rtf = new Intl.DateTimeFormat(locale, {
    localeMatcher: 'best fit',
    dateStyle: 'short',
    timeStyle: 'medium',
  });

  return rtf.format(val);
}

const formatDuration = (seconds, format = 'short', unitSeparator = ' ', valueSeparator = ' ') => {
  if (!seconds) return 'None';

  const units = [
    {formats: {short: 'h', long: 'h'}, coeff: 60 * 60},
    {formats: {short: 'm', long: 'min'}, coeff: 60},
    {formats: {short: 's', long: 'sec'}, coeff: 1},
  ];

  return units.reduce((obj, unit) => {
      const whole = Math.floor(obj.rest / unit.coeff);

      if (whole > 0) obj.str = `${obj.str}${unitSeparator}${whole}${valueSeparator}${unit.formats[format]}`;
      obj.rest -= whole * unit.coeff;

      return obj;
    },
    {str: '', rest: seconds},
  ).str;
}

const getTimeZoneOffset = () => {
  const tz = (new Date()).getTimezoneOffset();
  const hours = Math.floor(Math.abs(tz)/60);
  const minutes = Math.floor(Math.abs(tz) % 60);

  return `${tz > 0 ? '-' : '+'}${padNumber(hours)}:${padNumber(minutes)}`;
}

module.exports = {
  dateFromString,
  isValidDate,
  dateToUnixTimestamp,
  formatDate,
  formatDuration,
  getTimeZoneOffset
}